import * as React from 'react';

const SvgCopyOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M4 3h13v2H6v13H4V3Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 7v14H8V7h12ZM10 9v10h8V9h-8Z", fill: "currentColor" })));

export { SvgCopyOutline as default };
